import { getCountryFromPhone } from "../utils/phone";
import { getCountry } from "../utils/country";
import { LocalStorage } from "./LocalStorage";
import { isCountryVN } from "../utils/utils";

export class Address {
  constructor(id, uid, firstName, lastName, phoneNumber, email, address, addressOption, city, state, country, zipCode, ward, addressType) {
    this.id = id;
    this.uid = uid;
    this.firstName = firstName;
    this.lastName = lastName;
    this.phoneNumber = phoneNumber;
    this.email = email;
    this.address = address;
    this.addressOption = addressOption;
    this.city = city;
    this.state = state;
    this.country = country;
    this.zipCode = zipCode;
    this.ward = ward;
    this.addressType = addressType;
  }

  static fromApiObject(input) {
    let result = new Address();
    if (input && typeof (input) === "object") {
      result = new Address(
        input.id,
        input.uid,
        input.first_name,
        input.last_name,
        input.phone,
        input.email,
        input.address_1,
        input.address_2,
        input.province || input.city || "",
        input.state,
        input.country,
        input.postal_code,
        input.ward,
        input.address_type,
      );
    }

    if (!result.country && result.phoneNumber) {
      const country = getCountryFromPhone(result.phoneNumber);
      if (country) {
        result.country = country;
      }
    }
    return result;
  }

  isBox() {
    let isVN = isCountryVN(getCountryFromPhone(this.phoneNumber));
    return !!this.firstName && !!this.country && !!this.address && !!this.phoneNumber && !!this.email && !!this.state && !!this.city && (isVN || (!isVN && !!this.zipCode));
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Address.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Address.fromApiObject(input)];
    }

    return [];
  }

  getAdressFull() {
    const country = getCountryFromPhone(this.phoneNumber);
    let countryLabel = ""
    if (country) {
      let lang = LocalStorage.getLanguage() || "en"
      countryLabel = getCountry(country)[lang === "en" ? "name" : "name_vi"];
    }

    return `${this.address || ""}${this.addressOption ? ", " + this.addressOption : ""}${this.ward ? " " + this.ward : ""}${this.state ? ", " + this.state : ""}${this.city ? ", " + this.city : ""}${this.zipCode ? ", " + this.zipCode : ""}${countryLabel ? ", " + countryLabel : ""}`
  }

  /** @param {Address} billing */
  static genParamsBilling(billing) {
    var params = {};
    if (billing.id) params[Address.PARAMS.ID] = billing.id;
    if (billing.firstName) params[Address.PARAMS.FIRST_NAME] = billing.firstName;
    if (billing.lastName) params[Address.PARAMS.LAST_NAME] = billing.lastName;
    if (billing.phoneNumber) params[Address.PARAMS.PHONE] = billing.phoneNumber;
    if (billing.email) params[Address.PARAMS.EMAIL] = billing.email;
    if (billing.address) params[Address.PARAMS.ADDRESS] = billing.address;
    if (billing.addressOption) params[Address.PARAMS.ADDRESS_OPTION] = billing.addressOption;
    if (billing.city) params[Address.PARAMS.CITY] = billing.city;
    if (billing.state) params[Address.PARAMS.STATE] = billing.state;
    if (billing.ward) params[Address.PARAMS.WARD] = billing.ward;
    if (billing.country) params[Address.PARAMS.COUNTRY_CODE] = billing.country;
    if (billing.zipCode) params[Address.PARAMS.ZIP_CODE] = billing.zipCode;

    if (billing.addressType) params[Address.PARAMS.ADDRESS_TYPE] = billing.addressType;

    return params;
  }

  /**
   * 
   * @param {Address} shipping 
   * @param {Address} billing 
   * @returns {boolean}
   */
  static compareAddress(shipping = {}, billing = {}, hasCompareId = false) {
    if (Object.keys(shipping).length === 0 || Object.keys(billing).length === 0) {
      return false;
    }

    let result = true;
    let keys = Object.keys(shipping);
    for (let index = 0; index < keys.length; index++) {
      const key = keys[index];
      if (key === this.PARAMS.UID) continue;
      if (!hasCompareId && key === this.PARAMS.ID) continue;
      if (shipping[key] || billing[key]) {
        if (shipping[key] !== billing[key]) {
          result = false;
          break;
        }
      }
    }

    return result;
  }

  static PARAMS = {
    ID: "id",
    UID: "uid",
    FIRST_NAME: "first_name",
    LAST_NAME: "last_name",
    PHONE: "phone",
    EMAIL: "email",
    ADDRESS: "address_1",
    ADDRESS_OPTION: "address_2",
    CITY: "province",
    STATE: "state",
    COUNTRY_CODE: "country",
    ZIP_CODE: "postal_code",
    WARD: "ward",
    ADDRESS_TYPE: "address_type",
  }

  static TYPE = {
    SHIPPING_INFO: "shipping_info",
    BILLING_INFO: "billing_info",
  }
}